// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionArtworks_container__avQLX","heading":"SectionArtworks_heading__vPjLV","uploadTitle":"SectionArtworks_uploadTitle__zHwSm","text":"SectionArtworks_text__83IPw"};